import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {Paper} from '@mui/material';

import AlertInfo from '../../../dataObjects/AlertInfo';
import AlertInfoDialog from '../../../components/elements/AlertInfoDialog';
import SearchEngineTopSearchesSummary from './SearchEngineTopSearchesSummary';
import SearchEngineSearchQueriesList from './SearchEngineSearchQueriesList';
import SearchEngineDailyCountsChart, { SearchEngineDailyCount } from './SearchEngineDailyCountsChart';


const OcpfUsSearchEngine = () => {

    const [dailySummary, setDailySummary] = useState<SearchEngineDailyCount[]>();

    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    useEffect(() => {
        const getDailyTrendSummary = async () => {
            await fetch(`/ItDashboard/GetSearchQueriesSummary`)
                .then(result => result.json())
                .then(result => {
                    if (result.isError) {
                        let info = {
                            type: 'error',
                            title: 'Error: ItDashboard - GetSearchQueriesSummary',
                            errorMessage: result.errorMessage,
                            secondaryErrorMessage: result.secondaryErrorMessage
                        };
                        setAlertInfo(info);
                        setAlertInfoDialog(true);
                    }
                    else {
                        setDailySummary(result);
                    }
                }
                )
        }
        getDailyTrendSummary();
    }, []);

   
    return (
        <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
            <Stack direction="row" spacing={2} marginTop={2} marginBottom={3} alignItems="center" display="flex" justifyContent="flex-start">
                <Typography component="h2" variant="h6" sx={{ mb: 2, mt: 2 }}>
                    Public Search Engine Stats
                </Typography>
            </Stack>
            <Grid
                container
                spacing={2}
                columns={12}
                sx={{ mb: (theme) => theme.spacing(2) }}
            >
                {/*Total Count*/}
                <Grid item xs={7.5} component={Paper} >
                    <SearchEngineDailyCountsChart summary={dailySummary} ></SearchEngineDailyCountsChart>
                </Grid>
                <Grid item xs={0.2}></Grid>
                {/* Real time */}
                <Grid item xs={4.3} component={Paper} >
                    <SearchEngineTopSearchesSummary></SearchEngineTopSearchesSummary>
                </Grid>
            </Grid>
            <Grid container spacing={2} columns={12} marginTop={4} >
                <Grid item xs={9} component={Paper} >
                    <SearchEngineSearchQueriesList></SearchEngineSearchQueriesList>
                </Grid>
            </Grid>
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </Box>
    );
}

export default OcpfUsSearchEngine;
